import React, { Dispatch, SetStateAction, ChangeEvent, useState, useEffect, useContext } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import BusinessUnitContext from "../../../../contexts/BusinessUnitAccessContext";

interface BusinessUnitFieldProps {
    action: "view" | "update" | "create",
    qir: any,
    setQir: Dispatch<SetStateAction<any>>,
    onChange: (e: ChangeEvent<HTMLElement>) => void,
}

function BusinessUnitField({ action, qir, setQir, onChange }: BusinessUnitFieldProps) {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const businessUnitQueryParam = searchParams.get('businessUnit');
    const { assignedBusinessUnits } = useContext(BusinessUnitContext);
    const [selectedBusinessUnitId, setSelectedBusinessUnitId] = useState();
    const [tempSelectedBusinessUnit, setTempSelectedBusinessUnit] = useState<string>();

    // Set business unit from query param 'businessUnit'
    // Or if businessUnitId already exists on the QIR (e.g. update QIR)
    // Or select the only one if only one exists
    useEffect(() => {
        if (action === "create" && businessUnitQueryParam && assignedBusinessUnits) {
            let selectedbusinessUnit: any = assignedBusinessUnits.find((b: any) => b.name.toUpperCase() === businessUnitQueryParam.toUpperCase());
            if (selectedbusinessUnit) {
                setSelectedBusinessUnitId(selectedbusinessUnit.id);
                setQir((q: any) => ({
                    ...q,
                    businessUnitId: selectedbusinessUnit?.id,
                    siteId: selectedbusinessUnit?.siteId
                }));
            }
        } else if (action === "create" && businessUnitQueryParam && !assignedBusinessUnits) {
            // While we are loading assigned business units show the expected value as a readonly in the select
            setTempSelectedBusinessUnit(businessUnitQueryParam);
        }
        else if (qir.businessUnitId) {
            setSelectedBusinessUnitId(qir.businessUnitId);
        } else if (assignedBusinessUnits) {
            let businessUnit: any = assignedBusinessUnits.length === 1
                ? assignedBusinessUnits[0]
                : undefined;
            setSelectedBusinessUnitId(businessUnit?.id);
            setQir((q: any) => ({
                ...q,
                businessUnitId: businessUnit?.id,
                siteId: businessUnit?.siteId
            }));
        }
    }, [action, assignedBusinessUnits, businessUnitQueryParam, qir?.businessUnitId, setQir]);

    return (
        <Form.Group as={Row} className="mb-1" controlId="businessUnitId">
            <Form.Label column sm={3} className="required">{t<string>('QIRDetail.Fields.BusinessUnit')}</Form.Label>
            <Col sm={9}>
                {action === "create" && businessUnitQueryParam && !assignedBusinessUnits
                    ? <Form.Control type="text" size="sm" value={tempSelectedBusinessUnit} name="businessUnitId" onChange={onChange} readOnly />
                    : <Form.Select size="sm" required value={selectedBusinessUnitId ?? ""} name="businessUnitId" onChange={onChange} disabled={assignedBusinessUnits && assignedBusinessUnits.length === 1}>
                        <option key="0" value="">{t<string>('Application.Controls.DefaultSelect')}</option>
                        {
                            assignedBusinessUnits && assignedBusinessUnits.map((businessUnit: any, i: number) => {
                                return <option key={i + 1} value={businessUnit.id}>{businessUnit.display}</option>;
                            })
                        }
                    </Form.Select>
                }
            </Col>
        </Form.Group>
    );
}

export default BusinessUnitField;